export const getNotification = (store) => store.notification;
